import { SHA1 } from 'crypto-js'
import { enc } from 'crypto-js'
import { TripleDES } from 'crypto-js'

export class Simple3Des {
    private key: any = null;
    private iv: any = null;
    
    constructor(key: string) {
        this.key = this.truncateHash(key, 24);   // 24 came as an output from Console.WriteLine(TripleDes.KeySize \ 8) VB constructor code
        this.iv = this.truncateHash("", 8);      // 8 from Console.WriteLine(TripleDes.BlockSize \ 8)
    }

    public encryptData(data): string {
        // Convert to Utf16LE, encrypt and encode in Base64
        let ret = TripleDES.encrypt(enc.Utf16LE.parse(data), this.key, { iv: this.iv }).ciphertext.toString();
        return ret;
    }

    private truncateHash(key, length) {
        var ret: any = SHA1(enc.Utf16LE.parse(key)); // .Net uses Utf16LE as default encoding
        // Truncate key if necessary
        while (ret.sigBytes > length) {
            delete ret.words[ret.words.length - 1];
            ret.sigBytes -= 4;
        }

        // Expand key if necessary
        while (ret.sigBytes < length) {
            ret.words[ret.words.length] = 0;
            ret.sigBytes += 4;
        }
        return ret;
    }

}
